<template>
  <div id="app">
    <Modal />
    <router-view />
  </div>
</template>

<script>
import Modal from './components/Modal';
export default {
  name: 'App',
  components: {
    Modal,
  },
};
</script>

<style lang="scss">
@import './assets/global.scss';
</style>
